import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicGlobal({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 12.6c-.25 0-.84-.96-1.17-2.8h2.34c-.33 1.84-.92 2.8-1.17 2.8zM6.66 9.4c0-.43-.06-.9-.06-1.4 0-.5 0-.97.06-1.4h2.68c0 .43.06.9.06 1.4 0 .5 0 .97-.06 1.4H6.66zM2.4 8c0-.47.06-.94.18-1.4h2.67c-.05.46-.05.94-.05 1.4 0 .46 0 .94.05 1.4H2.58A5.6 5.6 0 012.4 8zM8 2.4c.25 0 .84.96 1.17 2.8H6.83c.33-1.84.92-2.8 1.17-2.8zm2.75 4.2h2.67c.24.92.24 1.88 0 2.8h-2.67c0-.46.05-.94.05-1.4 0-.46 0-.94-.05-1.4zm2.1-1.4H10.6c-.12-.84-.34-1.66-.65-2.45a5.6 5.6 0 012.9 2.45h.01zM6.07 2.75c-.32.79-.54 1.61-.66 2.45H3.16a5.6 5.6 0 012.9-2.45zM3.16 10.8H5.4c.12.84.34 1.66.65 2.45a5.6 5.6 0 01-2.9-2.45zm6.77 2.45c.32-.79.54-1.61.66-2.45h2.25a5.6 5.6 0 01-2.9 2.45z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicGlobal.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicGlobal.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicGlobal svgRef={ref} {...props} />);
export default ForwardRef;
